import 'zone.js';
import { CommonModule } from '@angular/common';
import { environment } from './environments/environment';
import { MessageService, ConfirmationService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { MyPreset } from './app/shared/theme';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  createHttpInterceptor,
  primeNgTranslationInitializer,
  provideGoogleMapsApiKey,
  provideTranslocoRoot,
} from '@rieaya-core';
import { bootstrapApplication } from '@angular/platform-browser';
import { ApiModule, Configuration } from '@rieaya-laundry-api';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app/app.routes';
import { ToastModule } from 'primeng/toast';
import { AppComponent } from './app/app.component';
import { importProvidersFrom } from '@angular/core';
import { TOKEN, LANG } from './app/core/utils/constant';

const httpInterceptor = createHttpInterceptor({
  tokenKey: TOKEN,
  langKey: LANG,
  panel: 1,
});

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([httpInterceptor])),
    importProvidersFrom(
      ApiModule.forRoot(
        () =>
          new Configuration({
            basePath: environment.apiUrl,
          })
      ),
      ToastModule,
      CommonModule
    ),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    MessageService,
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.my-app-dark',
        },
      },
    }),
    ConfirmationService,
    provideAnimationsAsync(),
    provideGoogleMapsApiKey(environment),
    primeNgTranslationInitializer(),
    provideTranslocoRoot(),
  ],
}).catch((err) => console.error(err));
